import { render, staticRenderFns } from "./CourseOutlineUnitInfo.vue?vue&type=template&id=a84aac56&"
import script from "./CourseOutlineUnitInfo.vue?vue&type=script&lang=js&"
export * from "./CourseOutlineUnitInfo.vue?vue&type=script&lang=js&"
import style0 from "./CourseOutlineUnitInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports